import { render, staticRenderFns } from "./UsuarioDetalhes.vue?vue&type=template&id=c3a349ac"
import script from "./UsuarioDetalhes.vue?vue&type=script&lang=js"
export * from "./UsuarioDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports